<template>
  <div style="height: 100%">
    <div id="carRight">
      <Input
        v-model="keyword"
        placeholder="搜索车辆"
        @on-search="getCarList"
        search
        style="margin-bottom: 10px"
      />
      <div
        v-if="isMore"
        v-show="checkboxData.length > 0"
        style="margin-top: 4px; margin-bottom: 10px"
      >
        <Checkbox
          :indeterminate="indeterminate"
          :value="checkAll"
          @click.prevent.native="handleCheckAll"
          >全选</Checkbox
        >
      </div>
      <ul id="carmsgTab">
        <li :class="{ active: tabValue == 3 }" @click="tabs(3)">
          全部({{ total }})
        </li>
        <li :class="{ active: tabValue == 2 }" @click="tabs(2)">
          在线({{ onlineArr.length }})
        </li>
        <li :class="{ active: tabValue == 1 }" @click="tabs(1)">
          离线({{ offlineArr.length }})
        </li>
      </ul>
      <div
        id="carmsg"
        class="gundongtiao"
        style="min-height: 180px"
        v-show="carsList.length > 0 || noOnline.length > 0"
      >
        <li
          v-for="(item, index) in carsList"
          :key="index"
          style="
            width: 100%;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 2.2;
          "
          :label="item.deviceId"
          @click="clickLi(item)"
          :class="{ blue: item.select }"
          v-show="item.show"
        >
          <span
            style="
              overflow: hidden;
              max-width: 40%;
              display: inline-block;
              vertical-align: bottom;
            "
            >{{ item.carNo }}</span
          >
          <car-statue :realTimeStatus="item.realTimeStatus"></car-statue>
          <span
            style="float: right; color: #999"
            :title="item.statusDuration + '分钟'"
            >{{ utils.changeTime(item.statusDuration) }}</span
          >
        </li>
        <div v-show="tabValue == 3">
          <dd
            v-for="(car, index) in noOnline"
            :key="index"
            style="color: #999; cursor: no-drop; line-height: 2.2"
          >
            {{ car.carNo }}【未上线】
          </dd>
        </div>
        <div v-show="tabValue == 3">
          <dd
            v-for="(car, index) in noData"
            :key="index"
            style="color: #999; cursor: no-drop; line-height: 2.2"
          >
            {{ car.carNo }}【无定位数据】
          </dd>
        </div>
      </div>
      <div
        v-show="carsList.length == 0 && noOnline.length == 0"
        style="text-align: center; padding-top: 20px"
        id="noCar"
      >
        暂无车辆
      </div>
      <Page
        :current="1"
        :total="total"
        :page-size="pageSize"
        @on-change="changePage"
        v-show="total > pageSize"
        style="margin-top:5px;"
      ></Page>
    </div>
    <Drawer
      placement="right"
      :closable="true"
      :mask="true"
      :draggable="false"
      width="80%"
      v-model="groupModel"
    >
      <groupTree isMore @groups='reGroups' @group='reGroup'></groupTree>
    </Drawer>
  </div>
</template>
<script>
import carStatue from "../common/carStatue.vue";
import groupTree from "../common/groupTree.vue"
import axios from "axios";
import "../common/treecss.css";
var t;
export default {
  props: ["isMore"],
  components: { carStatue,groupTree },
  data() {
    return {
      carsList: [], //获取到的车
      tabValue: 3,
      noOnline: [],
      noData: [],
      onlineArr: [],
      offlineArr: [],
      keyword: "",
      total: 0,
      pageSize: 100,
      pageNumber: 1,
      isFirst: false,
      groupModel:false,
      groupIdList:[]
    };
  },
  methods: {
    tabs(x) {
      this.tabValue = x;
      for (const i in this.carsList) {
        this.carsList[i].show = true;
        if (x == 1 && this.carsList[i].realTimeStatus != 1) {
          this.carsList[i].show = false; //离线,把不是离线的隐藏
        } else if (x == 2 && this.carsList[i].realTimeStatus == 1) {
          this.carsList[i].show = false; //在线，把离线的隐藏
        }
      }
    },
    getCarList() {
      if (this.isFirst) {
        this.utils.loading(this, "加载中");
      }
      
      axios({
        method: "post",
        url: axios.serverWeb + "/locate/getLocation",
        data: {
          keyword: this.keyword,
          groupIdList:this.groupIdList,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.total = res.data.data.total;
        this.allNum = data.length;
        this.onlineArr = [];
        this.offlineArr = [];
        this.noOnline = [];
        this.noData = [];
        for (const i in data) {
          if (data[i].realTimeStatus == 0) {
            //未上线
            this.noOnline.push(data[i]);
          } else {
            if (data[i].gcj02x == null) {
              //无定位数据
              this.noData.push(data[i]);
            } else {
              data[i].show = true;
              data[i].select = false;
              data[i].play = false;
              if (data[i].realTimeStatus == 1) {
                //离线
                this.offlineArr.push(data[i]);
              } else {
                //在线
                this.onlineArr.push(data[i]);
              }
            }
          }
        }
        this.carsList = this.onlineArr.concat(this.offlineArr);
        this.$emit("allCar", this.carsList, this.isFirst);
        this.tabs(this.tabValue);
      });
    },
    clickLi(row) {
      this.$emit("car", row);
    },
    changePage(v) {
      this.pageNumber = v;
      this.getCarListAndAutoGet();
    },
    //获取车辆列表并自动更新
    getCarListAndAutoGet() {
      this.isFirst = true;
      this.getCarList();
      clearInterval(t);
      t = setInterval(() => {
        this.isFirst = false;
        this.getCarList();
      }, 10000);
    },
    openGroup(){
      this.groupModel=true;
    },
    reGroups(v){
      this.groupIdList=[];
      for (const i in v) {
        this.groupIdList.push(v[i].groupId)
      }
      this.getCarListAndAutoGet();
    },
    reGroup(v){
      this.groupIdList=[v.groupId];
      this.getCarListAndAutoGet();
    }
  },
  mounted() {
    this.getCarListAndAutoGet();
  },
  watch: {
    keyword(v) {
      if (v.length == 0) {
        this.getCarList();
      }
    },
  },
  destroyed() {
    clearInterval(t);
  },
};
</script>
<style lang="">
#carLeft,
#carRight {
  width: 100%;
  float: left;
}
#carLeft {
  height: 30%;
  overflow: auto;
}
#carRight {
  height: calc(100% - 0px);
}
#carRight li:hover {
  background: #ebf8fc;
  cursor: pointer;
}
#carList {
  line-height: 2.3;
  height: calc(100% - 70px);
}
</style>


// WEBPACK FOOTER //
// src/components/common/carTool.vue